<template>
  <div class="info__tag" :class="{ blue, blueBg, greenBg, grey, reversed }">
    <template v-if="medium">
      <TextRegular>
        <span
          >{{ text }}
          <span v-if="Object.values(slots).length > 0" class="icon"
            ><slot
          /></span>
        </span>
      </TextRegular>
    </template>
    <template v-else>
      <small
        >{{ text }}
        <span v-if="Object.values(slots).length > 0" class="icon"
          ><slot
        /></span>
      </small>
    </template>
  </div>
</template>
<script setup>
import TextRegular from '@/components/shared/font/text/TextRegular.vue'
import { useSlots } from 'vue'
const slots = useSlots()

const props = defineProps({
  text: {
    type: String,
    default: ''
  },
  medium: Boolean,
  blue: Boolean,
  grey: Boolean,
  reversed: Boolean,
  blueBg: Boolean,
  greenBg: Boolean
})
</script>
<style lang="scss" scoped>
.info__tag {
  background: hotpink;
  color: $white;
  border-radius: 5px;
  padding: 2px 8px;
  font-size: 14px;
  display: flex;
  text-align: center;
  white-space: nowrap;
  width: fit-content;

  .icon {
    margin-left: 0.5rem;
  }
  .text {
    color: $white;
    .icon {
      color: $white;
    }
  }

  &.blue,
  &.blueBg {
    color: $blue-80;
    .text {
      color: $blue-80;
      .icon {
        color: $blue-80;
      }
    }
  }

  &.blueBg {
    background: $blue-30;
  }

  &.greenBg {
    background: $green-100;
    font-weight: 500;
  }

  &.grey {
    background: $black-30;
    color: $black-100;
    .text {
      color: $black-100;
      .icon {
        color: $black-100;
      }
    }
  }

  &.reversed {
    background: $pink-20;
    border: 1px solid $pink-100;
    color: $pink-100;
    .text {
      color: $pink-100;
      .icon {
        color: $pink-100;
      }
    }
    &.blue {
      background-color: $blue-40;
      border-color: $blue-80;
      border: 1px solid $blue-80;
    }
    &.grey {
      background: $white;
      color: $black-80;
      border: 1px solid $black-80;

      .text {
        color: $black-80;
        .icon {
          color: $black-80;
        }
      }
    }
  }
}
</style>
